<template>
  <!-- logo & banner -->
  <div class="header">
    <div class="header__nav">
      <div class="logo" @click="showMyccr()"></div>
    </div>

    <div class="header__banner">
      <!-- 图片 -->
      <div class="header__banner__cover">
      </div>

      <!-- 标题、介绍、按钮等 -->
      <div class="header__banner__info">
        <div class="title">MYCCR我的云课堂</div>
        <div class="brief">
          突破线下传统教学模式，立足于实用性的要求，与省内优质高校一线资深教师团队建立合作，
          聚合了丰富的学习内容，学习形式包括课程、课件、视频、音频等，配套学科评价与考核系统。
          提倡全方位学习，旨在帮助用户获得全面的、成体系的、从学习到评价一站式的学习体验，
          实现学有所获，学以致用！
        </div>
        <div class="action-group">
          <a class="action" href="#windows1">
            <i class="iconfont icon-xiazai1"></i> 前往下载
          </a>
        </div>
      </div>
    </div>
  </div>

  <!-- 下载 -->
  <ul class="download-list">
    <!-- 考霸思维 一级 MS office -->
    <li class="download-list__item app-exp" id="windows1">
      <div class="main">
        <div class="main__cover"></div>
        <div class="main__info">
          <div class="title">
            <div class="title__icon">
              <i class="iconfont icon-kecheng1" />
            </div>
            <div class="title__name">
              新境智慧教学平台
            </div>
          </div>
          <div class="division"></div>
          <div class="brief">
            平台所含实验由多所高校教师参与设计，符合教学需要，质量有保障，实验知识点覆盖全面。
            实验类型多，包含演示型、验证型、仿真型等三类虚拟仿真实验；还可完成Windows文件操作、MS Office操作、
            WPS Office 操作等操作型实验；以及Python、C语言等程序设计实验。
          </div>
          <div class="action-group">
            <div class="action" @click="downloadApp(urlList.appExp)">
              <i class="iconfont icon-xiazai1"></i> 点击下载
            </div>

            <div class="action orange" @click="downloadApp(urlList.appExpBaidu)">
              <i class="iconfont icon-xiazai1"></i> 网盘下载
            </div>
          </div>
        </div>
      </div>
    </li>

    <!--
    <li class="download-list__item app_ms_office">
      <div class="main">
        <div class="main__info">
          <div class="title">
            <div class="title__icon"><i class="iconfont icon-laoshi" /></div>
            <div class="title__name">
              考霸思维 - 一级MS Office
            </div>
          </div>
          <div class="division"></div>
          <div class="brief">
            结合全国计算机等级考试新大纲开发，不仅提供了练习模块，还配备模拟考试情景，能让考生尽快掌握相关知识点，并熟悉真实的考试环境。
          </div>
          <div class="action" @click="downloadApp(urlList.appKBOffice)">
            <i class="iconfont icon-xiazai1"></i> 点击下载
          </div>
        </div>
        <div class="main__cover"></div>
      </div>
    </li>

    <li class="download-list__item app_exam">
      <div class="main">
        <div class="main__cover"></div>
        <div class="main__info">
          <div class="title">
            <div class="title__icon"><i class="iconfont icon-laoshi" /></div>
            <div class="title__name">
              新境智能考试
            </div>
          </div>
          <div class="division"></div>
          <div class="brief">
            新境智能考试是一款智能化的考试系统，为学生提供全面的考试支持和评估，
            包括自动评分、老师评阅、学生成绩查看、成绩统计和试卷的归档。
          </div>
          <div class="action" @click="downloadApp(urlList.appExam)">
            <i class="iconfont icon-xiazai1"></i> 点击下载
          </div>
        </div>
      </div>
    </li>
    -->

    <!-- <li class="download-list__item empty">
      <el-empty description="暂无软件可下载" />
    </li> -->
  </ul>

  <!-- 底部 -->
  <footer-page />
</template>
<script>
import { reactive } from 'vue'
import footerPage from '../components/footer.vue'
// import request from '../utils/request'
// import { ElNotification } from 'element-plus'
export default {
  name: 'HomePage',
  components: {
    footerPage
  },
  setup() {
    const urlList = reactive({
      appExp: '', // 大机实验客户端 https://myccr.cn/media/myccr_setup.exe
      appKBOffice: 'https://myccr.cn/media/kaoba_MS Office(C)_setup.exe', // 考霸思维一级 ms office 客户端
      appExam: 'https://myccr.cn/media/', // 考试客户端
      appExpBaidu: 'https://pan.baidu.com/s/13MpPEKH60f_Uhhbv9o0siw?pwd=ziwp'
    })

    // 读取json中的下载地址
    function readJson() {
      const json = require('../assets/url.json')
      // console.log(json.download_url)
      urlList.appExp = json.download_url
    }

    // 获取 APP下载列表
    // function getDownloadAppList() {
    //   request({
    //     url: 'resource/appversion/latest/',
    //     method: 'get',
    //   }).then((res) => {
    //     res.data.data.forEach(item => {
    //       const { os, url } = item
    //       switch (os) {
    //         case 10:
    //           urlList.appExp = url //云课堂客户端（大机实验）
    //           break
    //       }
    //     })
    //   })
    // }

    // 下载APP
    function downloadApp(url) {
      window.open(url)
      // ElNotification({
      //   title: '提示',
      //   message: '系统维护中，请于2月28日之后下载使用。',
      //   type: 'warning',
      //   duration: 0
      // })
    }

    // 打开云课堂
    function showMyccr() {
      window.open('https://myccr.net/#/login')
    }

    // 获取应用下载地址
    // getDownloadAppList()

    // 获取下载地址
    readJson()

    return {
      urlList,
      downloadApp,
      showMyccr
    }
  }
}
</script>
<style lang="less" scoped>
  @import "@/styles/mixins";
  @import "@/styles/colors";

  .custom-action{
    width: 150px;
    height: 40px;
    border-radius: 5px;
    cursor: pointer;
    .absoluteCenter();
  }

  .header {
    height: 490px;
    padding-top: 20px;
    background: url('../assets/img/bg.jpg') no-repeat center center;
    background-size: cover;

    &__nav {
      margin: 0 auto;
      .minWidth;
      .logo {
        width: 160px;
        height: 50px;
        background: url('../assets/img/logo_text.jpg') no-repeat center center;
        cursor: pointer;
      }
    }

    &__banner {
      .minWidth;
      display: flex;
      margin: 0 auto;
      margin-top: 70px;

      &__cover {
        width: 354px;
        height: 290px;
        background: url('../assets/img/computer.png') no-repeat center center;
        background-size: cover;
        margin-left: 30px;
      }

      &__info {
        width: 600px;
        margin-left: 120px;
        color: #fff;
        .title {
          font-size: 42px;
          margin-bottom: 25px;
          font-weight: bold;
        }
        .brief {
          font-size: 14px;
          line-height: 24px;
          margin-bottom: 24px;
        }
        .action-group {
          display: flex;
          .action {
            border: 1px solid #fff;
            color: @blue;
            background: #fff;
            .custom-action;

            &:nth-child(1) {
              color: #fff;
              background: transparent;
            }

            .iconfont {
              margin-right: 7px;
            }
          }
        }
      }
    }
  }

  .download-list {
    padding: 50px 0 50px;
    &__item {
      padding: 30px 0;

      &:not(:last-child) {
        .main{
          padding-bottom: 65px;
          border-bottom: 1px solid @light-blue;
        }
      }

      .main {
        max-width: 960px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;

        &__info {
          .title {
            display: flex;
            align-items: center;

            &__name {
              flex: 1;
              font-size: 20px;
              margin-left: 10px;
              line-height: 1.5;
              text-align: left;
              font-weight: bold;
            }

            &__icon {
              border-radius: 2px;
              width: 36px;
              height: 36px;
              background: #E6F1FC;
              .absoluteCenter;

              .iconfont{
                color: @blue;
                font-size: 24px;
              }
            }
          }
          .division {
            height: 5px;
            width: 60px;
            margin: 15px 0 20px;
            border-radius: 4px;
            background: #E6F1FC;
          }
          .brief {
            margin-bottom: 20px;
            font-size: 14px;
            max-width: 500px;
            line-height: 24px;
          }
          .action {
            background-color: @blue;
            color: @background-white;
            .custom-action;

            &:hover {
              opacity: .8;
              transition: .3s all;
            }

            .iconfont {
              margin-right: 7px;
            }
          }
        }

        &__cover {
          width: 350px;
          height: 220px;
          background: @light-blue;
          border-radius: 16px;
          .absoluteCenter;

          .iconfont{
            color: @blue;
            font-size: 180px;
          }
        }
      }

      &.app-exp{
        .main__cover{
          background: url(../assets/img/cover-exp.jpg) no-repeat center center;
          background-size: cover;
        }
      }

      &.app_ms_office{
        .main__cover{
          background: url(../assets/img/cover-kb.jpg) no-repeat center center;
          background-size: cover;
        }
      }

      &.app_exam{
        .main__cover{
          background: url(../assets/img/cover-exam.jpg) no-repeat center center;
          background-size: cover;
        }
      }
    }
  }

  .action-group{
    display: flex;
    align-items: center;
    .action {
      margin-right: 15px;
      &.orange{
        background: @orange;
      }
    }
  }

  @media screen and (max-width: 1120px) {
    .header {
      background: url('../assets/img/bg_sm.jpg') no-repeat center center;
      background-size: cover;
      &__nav {
        width: 100%;
        .logo {
          margin: 20px auto;
          border-radius: 5px;
        }
      }

      &__banner {
        width: 100%;
        margin-top: 30px;

        &__cover {
          display: none;
        }

        &__info {
          width: 100%;
          flex-direction: column;
          margin-left: 0;
          padding: 0 30px;
          .absoluteCenter;

          .title{
            font-size: 36px;
          }

          .brief {
            text-align: center;
            margin-bottom: 30px;
            max-width: 750px;
          }
        }
      }
    }

    .download-list {
      &__item {
        .main {
          width: 100%;
          padding: 0 20px;
          text-align: center;

          &__info {
            width: 100%;
            flex-direction: column;
            .absoluteCenter;
            .brief{
              width: 100%;
              padding: 0 15px;
            }
          }
          &__cover {
            display: none;
          }
        }
      }
    }
  }
</style>